<div class="row mb-2 paginador">
  <div class="col-4">
    <label>Itens por página: &nbsp;</label>
    <select [(ngModel)]="pageSize" (change)="onSearchEvent(1)">
      <option *ngFor="let item of itemsPerPage" [value]="item">
        {{ item }}
      </option>
    </select>
  </div>
  <div class="col-4 text-center">
    {{ totalItems === 0 ? 0 : firstItemOnPage }} - {{ lastItemOnPage }} de
    {{ totalItems }}
  </div>
  <div class="col-4">
    <ul class="pagination justify-content-end">
      <li
        class="page-item disabled"
        [ngClass]="{ disabled: currentPage === 1 }"
      >
        <a class="page-link" (click)="onSearchEvent(1)" title="Primeira página">
          <fa-icon [icon]="faAngleDoubleLeft" title="Visualizar"></fa-icon>
        </a>
      </li>
      <li
        class="page-item disabled"
        [ngClass]="{ disabled: currentPage === 1 }"
      >
        <a
          class="page-link"
          (click)="onSearchEvent(currentPage - 1)"
          title="Página anterior"
        >
          <fa-icon [icon]="faAngleLeft" title="Visualizar"></fa-icon>
        </a>
      </li>

      <li
        class="page-item"
        *ngFor="let page of listedPages"
        [ngClass]="{ disabled: page === currentPage }"
      >
        <a class="page-link" (click)="onSearchEvent(page)">{{ page }}</a>
      </li>

      <li
        class="page-item"
        [ngClass]="{ disabled: currentPage === totalPages || totalPages === 0 }"
      >
        <a
          class="page-link"
          (click)="onSearchEvent(currentPage + 1)"
          title="Próxima página"
        >
          <fa-icon [icon]="faAngleRight" title="Visualizar"></fa-icon>
        </a>
      </li>
      <li
        class="page-item"
        [ngClass]="{ disabled: currentPage === totalPages || totalPages === 0 }"
      >
        <a
          class="page-link"
          (click)="onSearchEvent(totalPages)"
          title="Última página"
        >
          <fa-icon [icon]="faAngleDoubleRight" title="Visualizar"></fa-icon>
        </a>
      </li>
    </ul>
  </div>
</div>
